import { SectionWrapper } from '../../components/SectionWrapper';

import magicAndScienceUrl from '@/images/magic_and_science.jpg';
import styles from './HumanitiesHeroSection.module.css';

export function HumanitiesHeroSection() {
  return (
    <SectionWrapper background="white" data-testid="humanities-section-hero">
      <div className={styles.layout}>
        <div className={styles.copy}>
          <p className={styles.eyebrow}>KUDU HUMANITIES</p>
          <h1 className={styles.title}>
            Reimagining humanities education in the age of AI
          </h1>
          <p className={styles.subhead}>
            Artificial intelligence is transforming education. Most of that
            transformation has focused on efficiency, automation, and content
            generation.
          </p>
          <p className={styles.premise}>
            Kudu Humanities was founded on a different premise.
          </p>
        </div>

        <div className={styles.media}>
          <div className={styles.mediaFrame}>
            <img
              alt="Where the study of magic meets the study of science."
              className={styles.mediaImage}
              src={magicAndScienceUrl}
            />
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
}
